import { getBooleanFromValue } from '@/global/utils/utils'

export default {
  computed: {
    fuelEditConfig () {
      return {
        title: this.$t('fleet/vehicle.fuel'),
        key: 'fuel',
        formData: this.formData?.item,
        onTabChange: () => {
          this.showMainEditButtons = true
        },
        editUpdate: (event) => {
          const { edit } = event || {}
          this.$set(this.disableTabs, 'canBus', edit)
          this.$set(this.disableTabs, 'readouts', edit)
          this.$set(this.disableTabs, 'documents', edit)
          this.$set(this.disableTabs, 'inspections', edit)
          this.$set(this.disableTabs, 'insurances', edit)
          this.$set(this.disableTabs, 'leasing', edit)
          this.$set(this.disableTabs, 'rangeLimits', edit)
          this.$set(this.disableTabs, 'serviceIntervals', edit)
          this.$set(this.disableTabs, 'serviceHistory', edit)
          this.$set(this.disableTabs, 'comments', edit)
          this.$set(this.disableTabs, 'damages', edit)
        },
        tabContent: [
          {
            title: this.$t('fleet/vehicle.fuel'),
            component: this.columnsContentComponent,
            rows: [
              {
                disabled: !getBooleanFromValue(this.permissions?.canEdit),
                columnsCount: 4,
                fields: [
                  {
                    key: 'fuel_type',
                    label: this.$t('fleet/vehicle.fuel_type'),
                    type: 'autocomplete',
                    autocomplete_options: {
                      module: 'fleet',
                      route: 'vehicles/fuel-types'
                    },
                    visible: true,
                    editable: true,
                    creatable: true
                  },
                  {
                    key: 'fuel_tank_capacity',
                    label: this.$t('fleet/vehicle.fuel_tank_capacity'),
                    field_type: 'number',
                    visible: true,
                    editable: true,
                    creatable: true
                  },
                  {
                    key: 'idle_fuel_consumption',
                    label: this.$t('fleet/vehicle.idle_fuel_consumption'),
                    field_type: 'number',
                    visible: true,
                    editable: true,
                    creatable: true
                  },
                  {
                    key: 'urban_fuel_consumption',
                    label: this.$t('fleet/vehicle.urban_fuel_consumption'),
                    field_type: 'number',
                    visible: true,
                    editable: true,
                    creatable: true
                  },
                  {
                    key: 'open_road_fuel_consumption',
                    label: this.$t('fleet/vehicle.open_road_fuel_consumption'),
                    field_type: 'number',
                    visible: true,
                    editable: true,
                    creatable: true
                  },
                  {
                    key: 'combined_fuel_consumption',
                    label: this.$t('fleet/vehicle.combined_fuel_consumption'),
                    field_type: 'number',
                    visible: true,
                    editable: true,
                    creatable: true
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}
